module.exports = __webpack_public_path__ + "img/charging-kW.f904c59c.svg";